// Presence heartbeat — cliente envia `presence:ping` no namespace /inbox a cada
// 30s pra manter o user na lista de online (backend grava no ZSET, expira em
// 60s). Roda apenas enquanto o user está autenticado.
import type { Store } from '@reduxjs/toolkit';
import { getSocket } from './client';

const HEARTBEAT_INTERVAL_MS = 30_000;

interface AuthShape {
  auth?: { isAuthed: boolean };
}

let interval: ReturnType<typeof setInterval> | null = null;

function pingIfAuthed(getState: () => AuthShape) {
  const isAuthed = getState().auth?.isAuthed ?? false;
  if (!isAuthed) return;
  const socket = getSocket('inbox');
  if (!socket.connected) return;
  socket.emit('presence:ping');
}

/**
 * Anexa o heartbeat de presença ao boot. Idempotente — segunda chamada não cria
 * outro setInterval.
 */
export function attachPresenceHeartbeat(store: Store<AuthShape>): void {
  if (interval) return;
  interval = setInterval(() => pingIfAuthed(() => store.getState()), HEARTBEAT_INTERVAL_MS);
}

/** Helper de testes: limpa o timer. */
export function detachPresenceHeartbeat(): void {
  if (interval) {
    clearInterval(interval);
    interval = null;
  }
}

/** Constante exportada pra reuso em testes. */
export const PRESENCE_HEARTBEAT_INTERVAL_MS = HEARTBEAT_INTERVAL_MS;
